export function initHomeFaces(main: HTMLElement) {

	let mainPart = main.querySelector('[data-part="main"]');

	let obs = new IntersectionObserver(
		(es) => {
			es.forEach(
				(e) => {
					if (e.isIntersecting) {
						obs.disconnect();
						run();
					}
				}
			)
		},
		{
			rootMargin: '-20% 0px -20% 0px'
		}
	);
	if (mainPart) {
		obs.observe(mainPart);
	}

	function run() {
		main.classList.remove('before');
	}

}
